import React from "react";
import { WHATSAPP_URL } from "../data/site";

export default function WhatsAppFloat() {
    return (
        <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noreferrer"
            data-testid="whatsapp-float"
            aria-label="Contattaci su WhatsApp"
            className="fixed bottom-6 right-6 z-40 group"
        >
            <span className="absolute inset-0 rounded-full bg-gold/40 blur-xl group-hover:bg-gold/60 transition-all animate-pulse" />
            <span className="relative flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-[0_8px_24px_rgba(37,211,102,0.45)] hover:scale-110 transition-transform duration-300 ring-2 ring-white/10">
                <svg viewBox="0 0 24 24" width="26" height="26" fill="currentColor" aria-hidden="true">
                    <path d="M20.52 3.48A11.91 11.91 0 0 0 12.06 0C5.5 0 .17 5.33.17 11.89c0 2.1.55 4.15 1.6 5.96L0 24l6.31-1.66a11.87 11.87 0 0 0 5.75 1.47h.01c6.56 0 11.89-5.33 11.89-11.89 0-3.18-1.24-6.17-3.44-8.44zM12.07 21.5h-.01a9.55 9.55 0 0 1-4.87-1.33l-.35-.21-3.74.98 1-3.65-.23-.37a9.5 9.5 0 0 1-1.46-5.03c0-5.26 4.29-9.55 9.56-9.55 2.55 0 4.95.99 6.75 2.8a9.48 9.48 0 0 1 2.8 6.76c0 5.26-4.29 9.56-9.55 9.56zm5.44-7.16c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15s-.76.97-.93 1.17c-.17.2-.34.22-.64.07-.3-.15-1.26-.46-2.4-1.48-.89-.8-1.49-1.78-1.66-2.08-.17-.3-.02-.46.13-.61.14-.14.3-.34.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.62-.92-2.22-.24-.58-.48-.5-.67-.51l-.57-.01c-.2 0-.52.07-.8.37-.27.3-1.04 1.01-1.04 2.46s1.07 2.85 1.22 3.05c.15.2 2.1 3.22 5.1 4.52.71.31 1.27.49 1.7.63.71.22 1.36.19 1.87.12.57-.09 1.76-.72 2.01-1.41.25-.7.25-1.29.17-1.41-.07-.12-.27-.2-.57-.35z" />
                </svg>
            </span>
        </a>
    );
}
